import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import { Dashboard } from './components/Dashboard';
import { ContratosList } from './components/contratos/ContratosList';
import { ClientesList } from './components/clientes/ClientesList';
import { ProcessosList } from './components/processos/ProcessosList';
import { UsuariosList } from './components/usuarios/UsuariosList';
import { BuscaIa } from './components/ia/BuscaIa'; // Importando o novo componente

// Rota Protegida
const PrivateRoute = ({ children }: { children: React.ReactElement }) => {
    const isAuthenticated = !!localStorage.getItem('gestjus_token');
    return isAuthenticated ? children : <Navigate to="/" />;
};

function App() {
    return (
        <Router>
            <Routes>
                {/* Rota Pública */}
                <Route path="/" element={<Login />} />

                {/* Rotas Privadas */}
                <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                <Route path="/contratos" element={<PrivateRoute><ContratosList /></PrivateRoute>} />
                <Route path="/clientes" element={<PrivateRoute><ClientesList /></PrivateRoute>} />
                <Route path="/processos" element={<PrivateRoute><ProcessosList /></PrivateRoute>} />
                <Route path="/usuarios" element={<PrivateRoute><UsuariosList /></PrivateRoute>} />
                <Route path="/busca-ia" element={<PrivateRoute><BuscaIa /></PrivateRoute>} />

                {/* Fallback: Qualquer rota não encontrada joga para o login */}
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Router>
    );
}

export default App;